import './App.css';
import React, { useReducer, useCallback, useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { saveAs } from 'file-saver';
import Form from './pages/Form/Form.js';
import { MainApi } from './utils/MainApi'
import Home from './pages/Home/Home.js';
import Preview from './pages/Preview/Preview.js';
import KpLoader from './components/KpLoader/KpLoader';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import LoginPage from './pages/LoginPage/LoginPage.js';
import Profile from './pages/Profile/Profile.jsx';
import ContractorsList from './pages/Contractors/ContractorsList.jsx';
import ContractorDetails from './pages/Contractors/ContractorDetails.jsx';
import OrganisationList from './pages/Organisation/OrganisationList.jsx';
import OrganisationForm from './pages/Organisation/OrganisationForm.jsx';
import OrganisationDetails from './pages/Organisation/OrganisationDetails.jsx';
import ContractorForm from './pages/Contractors/ContractorForm.jsx';
import EventsList from './pages/Events/EventsList.jsx';
import EventDetails from './pages/Events/EventDetails.jsx';
import EventForm from './pages/Events/EventForm.jsx';
import MenuList from './pages/Menu/MenuList.jsx';
import MenuDetails from './pages/Menu/MenuDetails.jsx';
import MenuForm from './pages/Menu/MenuForm.jsx';
import Header from './components/Header/Header';
import AppLayout from './components/Layout/AppLayout';
import useAuthStore from './hooks/useAuthStore.js';
import useKpStore from './hooks/useKpStore';
import { kpPreviewSelectors, kpPrintSelectors } from './utils/const.js'
import { calculateKpTotal } from './utils/calculateKpTotal';
import PrototypeKp from './pages/Prototype/PrototypeKp';
import { downloadFile } from './utils/downloadFile';
import TelegramAuthProvider from './components/Telegram/TelegramAuthProvider';
import { isTMA } from '@telegram-apps/sdk';

function App() {
  const [isNewKp, setIsNewKp] = useState(true)
  const [updetedRows, setUpdatedRows] = useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const isAuth = useAuthStore((state) => state.isAuth);
  const authReady = useAuthStore((state) => state.authReady);
  const initAuth = useAuthStore((state) => state.initAuth);
  const { formData, resetFormData, resetListsKp, updateField } = useKpStore();
  const { user } = useAuthStore();

  const setFormData = useKpStore((s) => s.setFormData);
  const setListsKp = useKpStore((s) => s.setListsKp);
  const listsKp = useKpStore((s) => s.listsKp);

  const getEmptyFormData = () => ({
    managerName: user?.name || '',
    managerJobTitle: user?.job || '',
    managerEmail: user?.email || '',
    managerTel: user?.tel || '',
    managerPhoto: user?.photo || '',
    kpNumber: '',
    kpDate: new Date().toISOString().split('T')[0],
    contractNumber: '',
    contractDate: new Date().toISOString().split('T')[0],
    startEvent: new Date().toISOString().split('T')[0],
    endEvent: new Date().toISOString().split('T')[0],
    startTimeStartEvent: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
    endTimeStartEvent: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
    startTimeEndEvent: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
    endTimeEndEvent: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
    eventPlace: '',
    countOfPerson: '',
    logisticsCost: 0,
    isWithinMkad: true,
    listTitle: '',
    contractorId: null,
    eventId: null
  });

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  useEffect(() => {
    if (location.pathname === '/new' || location.pathname === '/new-legacy') {
      setIsNewKp(true);
      resetFormData();
      resetListsKp();
    }
  }, [location.pathname, resetFormData, resetListsKp]);

  useEffect(() => {
    if (user && isNewKp) {
      resetFormData();
    }
  }, [user, isNewKp, resetFormData]);

  // function reducer(state, action) {
  //   switch (action.type) {
  //     // case 'UPDATE_LISTS':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: action.payload.map(list => ({
  //     //       ...list,
  //     //       rows: [...(list.rows || [])].sort((a, b) => (a.order - b.order) || ((a.id ?? 0) - (b.id ?? 0))),
  //     //     })),
  //     //   };
  //     // case 'ADD_ROW_IN_PDF':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: [...state.listsKp, { id: state.listsKp.length + 1, rows: action.payload }]
  //     //   };
  //     // case 'DELETE_ROW':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: state.listsKp.map(list => {
  //     //       if (list.id === action.payload.listId) {
  //     //         const updatedRows = list.rows.filter((_, index) => index !== action.payload.rowIndex);
  //     //         return { ...list, rows: updatedRows };
  //     //       }
  //     //       return list;
  //     //     })
  //     //   };

  //     // case 'ADD_ROW_ON_LIST': {
  //     //   const { listId, row } = action.payload;
  //     //   return {
  //     //     ...state,
  //     //     listsKp: state.listsKp.map((l) => {
  //     //       if (l.id !== listId) return l;
  //     //       const rows = [...(l.rows || []), row];
  //     //       // (опционально) жёстко удерживаем порядок по order
  //     //       rows.sort((a, b) => (a.order - b.order) || ((a.id ?? 0) - (b.id ?? 0)));
  //     //       return { ...l, rows };
  //     //     }),
  //     //   };
  //     // }
  //     // case 'REFRESH_DATA':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: [...state.listsKp]
  //     //   };

  //     // case 'SYNC_ROW_UPDATE':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: state.listsKp.map(list => {
  //     //       if (list.id === action.payload.listId) {
  //     //         return {
  //     //           ...list,
  //     //           rows: list.rows.map((row, idx) =>
  //     //             idx === action.payload.rowIndex
  //     //               ? { ...row, ...action.payload.updatedRow }
  //     //               : row
  //     //           )
  //     //         };
  //     //       }
  //     //       return list;
  //     //     })
  //     //   };
  //     // case 'SYNC_ALL_DATA':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: action.payload,
  //     //     allRowsData: action.payload // синхронизировать все данные
  //     //   };



  //     // case 'RESET_FORM':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: [],
  //     //   };

  //     // case 'UPDATE_ROW':
  //     //   setUpdatedRows([...updetedRows, action.payload.updatedRow])
  //     //   return {
  //     //     ...state,
  //     //     listsKp: state.listsKp.map(list => {
  //     //       if (list.id === action.payload.listId) {
  //     //         return {
  //     //           ...list,
  //     //           rows: list.rows.map((row, index) =>
  //     //             index === action.payload.rowIndex
  //     //               ? {
  //     //                 ...row,
  //     //                 ...action.payload.updatedRow,
  //     //                 order: Number.isInteger(action.payload.updatedRow?.order)
  //     //                   ? action.payload.updatedRow.order
  //     //                   : row.order,
  //     //               }
  //     //               : row
  //     //           )
  //     //         };
  //     //       }
  //     //       return list;
  //     //     })
  //     //   };
  //     // case 'DELETE_LIST':
  //     //   return {
  //     //     ...state,
  //     //     listsKp: state.listsKp.filter(obj => obj.id !== action.payload.id)
  //     //   };
  //     default:
  //       return state;
  //   }
  // }
  // const [state, dispatch] = useReducer(reducer, { listsKp: [] });
  // const { listsKp } = state;
  // useEffect(() => {
  //   setListsKp(state.listsKp);
  // }, [state.listsKp]);
  useEffect(() => {
    if (!isNewKp) return;
    if (!user || !user.tel) return;

    const initialData = getEmptyFormData();
    // dispatch({
    //   type: 'UPDATE_FORM_DATA',
    //   payload: initialData
    // });
    setFormData(initialData);
  }, [user?.email, isNewKp]);


  useEffect(() => {
    const fetchLastKpNumber = async () => {
      try {
        const lastKpNumber = await MainApi.getLastKpNumber();

        const nextNumber = lastKpNumber ? parseInt(lastKpNumber) + 1 : 467;

        // dispatch({
        //   type: 'UPDATE_FORM_DATA',
        //   payload: { kpNumber: nextNumber }
        // });
        updateField("kpNumber", nextNumber)

      } catch (err) {
        console.log('Ошибка: ' + err);
      }
    };

    if (isNewKp) {
      fetchLastKpNumber();
    }
  }, [isNewKp]);

  useEffect(() => {
    // При изменении listsKp синхронизировать все данные
    // dispatch({ type: 'SYNC_ALL_DATA', payload: listsKp });
    setListsKp(listsKp);

  }, [listsKp]);

  const getProductWeightWithMeasure = (productWeight, typeOfProduct) => {
    if (!productWeight) return productWeight;
    return typeOfProduct === 'eat' ? `${productWeight}г` : `${productWeight}мл`;
  };

  // Приводим DD.MM.YYYY -> YYYY-MM-DD, всё остальное аккуратно пропускаем
  const toISO = (v) => {
    if (!v) return null;
    if (/^\d{2}\.\d{2}\.\d{4}$/.test(v)) {
      const [d, m, y] = v.split('.');
      return `${y}-${m}-${d}`;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v; // уже ISO
    if (v === 'Invalid date') return null;
    const d = new Date(v);
    return isNaN(d) ? null : d.toISOString().slice(0, 10);
  };
  const toHHMM = (v) => {
    if (!v) return null;
    if (/^\d{2}:\d{2}$/.test(v)) return v; // уже в нормальном виде
    if (/^\d{2}:\d{2}:\d{2}/.test(v)) return v.slice(0, 5); // обрезаем секунды
    return v; // оставляем как есть
  };

  // Нормализуем только поля-даты формы КП
  const normalizeKpPayload = (data) => ({
    ...data,
    managerName: data.managerName || user?.name || '',
    kpDate: toISO(data.kpDate),
    contractDate: toISO(data.contractDate),
    startEvent: toISO(data.startEvent),
    endEvent: toISO(data.endEvent),
    startTimeStartEvent: toHHMM(data.startTimeStartEvent),
    endTimeStartEvent: toHHMM(data.endTimeStartEvent),
    startTimeEndEvent: toHHMM(data.startTimeEndEvent),
    endTimeEndEvent: toHHMM(data.endTimeEndEvent),
    eventId: data.eventId || null,
  });

  // Форматирование цены
  const GetPrice = useCallback((price) => {
    return `${Math.round(price).toLocaleString('ru-RU')} руб`;
  }, []);

  // Корректное склонение слова "человек"
  const getDeclination = useCallback((num) => {
    const n = parseInt(num, 10);
    const remainder10 = n % 10;
    const remainder100 = n % 100;
    if (remainder100 >= 11 && remainder100 <= 14) {
      return `${n} человек`;
    }
    if (remainder10 === 1) {
      return `${n} человек`;
    }
    if (remainder10 >= 2 && remainder10 <= 4) {
      return `${n} человека`;
    }
    return `${n} человек`;
  }, []);

  const addToDb = async (formData, listsKp, updatedRows = []) => {
    console.log(formData);
    console.log(listsKp);

    // --- AUTO EVENT CREATION ---
    let finalEventId = formData.eventId;
    
    // Auto-create Event ONLY when eventId is missing AND minimal fields are present
    if (!finalEventId && formData.listTitle && formData.startEvent && formData.eventPlace) {
      try {
        console.log('Auto-creating event from KP data...');
        const newEventPayload = {
          title: formData.listTitle,
          eventPlace: formData.eventPlace,
          countOfPerson: (formData.countOfPerson === '' || formData.countOfPerson == null) ? null : Number(formData.countOfPerson),
          startEvent: toISO(formData.startEvent) || null,
          endEvent: toISO(formData.endEvent) || null,
          startTimeStartEvent: toHHMM(formData.startTimeStartEvent) || null,
          endTimeStartEvent: toHHMM(formData.endTimeStartEvent) || null,
          startTimeEndEvent: toHHMM(formData.startTimeEndEvent) || null,
          endTimeEndEvent: toHHMM(formData.endTimeEndEvent) || null
        };
        const createdEvent = await MainApi.createEvent(newEventPayload);
        finalEventId = createdEvent.id;
        
        // Update local state if needed
        updateField('eventId', finalEventId);
      } catch (err) {
        console.error('Ошибка при автосоздании события:', err);
      }
    }
    
    // Mutate local formData to ensure the new eventId is included in normalizeKpPayload
    const updatedFormData = { ...formData, eventId: finalEventId };
    // --- END AUTO EVENT CREATION ---

    // --- AUTO CONTRACTOR CREATION ---
    let finalContractorId = formData.contractorId;
    
    // Auto-create Contractor ONLY when contractorId is missing AND companyName is present
    if (!finalContractorId && formData.companyName) {
      try {
        console.log('Auto-creating contractor from KP data...');
        const newContractorPayload = {
          companyName: formData.companyName,
          contactPerson: formData.contactPerson || null,
          phone: formData.phone || null,
          email: formData.email || null,
        };
        const createdContractor = await MainApi.createContractor(newContractorPayload);
        finalContractorId = createdContractor.id;
      } catch (err) {
        console.error('Ошибка при автосоздании контрагента:', err);
      }
    }
    
    updatedFormData.contractorId = finalContractorId;
    // --- END AUTO CONTRACTOR CREATION ---

    // --- UPDATE EVENT CONTRACTOR ---
    if (formData.updateEventContractor === true && finalEventId && finalContractorId) {
      try {
        console.log('Event contractor updated');
        await MainApi.updateEvent(finalEventId, {
          title: formData.listTitle,
          contractorId: finalContractorId,
          startEvent: formData.startEvent,
          endEvent: formData.endEvent,
          startTimeStartEvent: formData.startTimeStartEvent,
          endTimeStartEvent: formData.endTimeStartEvent,
          startTimeEndEvent: formData.startTimeEndEvent,
          endTimeEndEvent: formData.endTimeEndEvent,
          eventPlace: formData.eventPlace,
          countOfPerson: formData.countOfPerson
        });
      } catch (err) {
        console.error('Ошибка при обновлении привязки события:', err);
      }
    }
    // --- END UPDATE EVENT CONTRACTOR ---

    if (isNewKp) {
      try {
        const { finalTotalAmount } = calculateKpTotal(listsKp, updatedFormData);
        
        // 1) нормализуем шапку КП по датам
        const kpPayload = {
          ...normalizeKpPayload(updatedFormData),
          totalAmount: finalTotalAmount
        };

        // 2) создаём КП
        const kpRes = await MainApi.addKp(kpPayload);
        console.log('KP создан:', kpRes);

        // dispatch({
        //   type: 'UPDATE_FORM_DATA',
        //   payload: { ...formData, id: kpRes.id },
        // });
        updateField("kpNumber", kpRes.id)

        // 3) создаём списки и строки
        let updatedLists = [];

        if (listsKp?.length > 0 && kpRes.id) {
          updatedLists = await Promise.all(
            listsKp.map(async (list) => {
              const listRes = await MainApi.addList({
                ...updatedFormData,
                startEvent: toISO(updatedFormData.startEvent),
                endEvent: toISO(updatedFormData.endEvent),
                kpId: kpRes.id,
              });
              let createdRows = [];
              if (list.rows?.length > 0) {
                createdRows = await Promise.all(
                  list.rows.map((row, i) =>
                    MainApi.addRow({
                      ...row,
                      listId: listRes.id,
                      // если локально уже есть order — уважим его, иначе индекс
                      order: Number.isInteger(row.order) ? row.order : i,
                    })
                  )
                );
              }

              return {
                ...listRes,
                rows: createdRows
              };
            })
          );
          console.log('Списки созданы:', updatedLists);
        }

        // dispatch({
        //   type: 'UPDATE_LISTS',
        //   payload: updatedLists,
        // });
        setListsKp(updatedLists);


        // 4) редирект на предпросмотр по номеру (у тебя просмотр грузит по kpNumber)
        if (kpRes?.kpNumber) {
          navigate(`/kp/${kpRes.kpNumber}`);
        }

        setIsNewKp(false);
        console.log('✅ Все данные успешно записаны');
      } catch (err) {
        console.error('Ошибка при создании KP:', err);
        throw err;
      }
    } else {
      // Редактирование существующего КП: обновляем изменённые строки
      try {
        console.log('update');
        console.log(formData.kpNumber);

        const { finalTotalAmount } = calculateKpTotal(listsKp, updatedFormData);
        
        const updatePayload = {
          ...updatedFormData,
          totalAmount: finalTotalAmount
        };

        const updatedKp = await MainApi.updateKp(updatePayload, updatedFormData.kpNumber)
        console.log('✅ Данные коммерческого предложения обновлены');
        console.log(updatedKp?.kp.kpNumber);

        if (updatedKp?.kp.kpNumber) {
          navigate(`/kp/${updatedKp.kp.kpNumber}`);
        }
      } catch (err) {
        console.error('Ошибка при обновлении строк:', err);
        throw err;
      }
    }
  };


  const deleteRowFromDb = async (rowId) => {
    try {
      await MainApi.deleteRow(rowId);
      console.log('Строка удалена из БД');
    } catch (err) {
      console.error(err);
      toast.error('Ошибка при удалении строки из базы данных.');
    }
  };

  const updateRowInDb = async (updatedRow) => {
    try {
      await MainApi.updateRow(updatedRow);
      console.log('✅ Строка обновлена в БД');
    } catch (err) {
      console.error(err);
      toast.error('Ошибка при обновлении строки в базе данных.');
    }
  };

  const deleteListFromDb = async (listId) => {
    try {
      await MainApi.deleteList(listId);
      console.log('✅ Список удалён из БД');
    } catch (err) {
      console.error(err);
      toast.error('Ошибка при удалении списка из базы данных.');
    }
  };

  // Telegram caption отправляется с parseMode: 'HTML' (см. pdfDeliveryService.js),
  // поэтому значения экранируем, а заголовки/номер КП оборачиваем в <b>.
  const escapeTelegramHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const buildKpTelegramCaption = useCallback(() => {
    const contractorName = escapeTelegramHtml(formData.contractor?.companyName || formData.companyName || '—');
    const eventTitle = escapeTelegramHtml(formData.listTitle || '—');
    const eventDate = formData.startEvent
      ? new Date(formData.startEvent).toLocaleDateString('ru-RU')
      : '—';
    return [
      `<b>КП № ${escapeTelegramHtml(formData.kpNumber)}</b>`,
      `<b>Заказчик:</b> ${contractorName}`,
      `<b>Мероприятие:</b> ${eventTitle}`,
      `<b>Дата:</b> ${eventDate}`
    ].join('\n');
  }, [formData]);

  const exportHiddenPDF = useCallback(async () => {
    // сохраняем режим редактирования как существующий КП (как было)
    console.log('exportHiddenPDF started');
    console.log('Current user from store:', useAuthStore.getState().user);
    console.log('Current user photo:', useAuthStore.getState().user?.photo);
    setIsNewKp(false);

    // A4 landscape в мм
    const A4_WIDTH_MM = 297;
    const A4_HEIGHT_MM = 210;

    // Целевая «плотность» для растрового кадра (200 dpi даёт отличное качество печати)
    const TARGET_DPI = 200;
    const MM_PER_INCH = 25.4;
    const targetPxWidth = Math.round((A4_WIDTH_MM / MM_PER_INCH) * TARGET_DPI); // ~2338px

    // Хелпер: даунскейл холст до targetPxWidth и верни JPEG dataURL
    const canvasToJPEG = (srcCanvas, maxWidthPx = targetPxWidth, quality = 0.85) => {
      const { width, height } = srcCanvas;
      // если ширина и так меньше лимита — просто конвертируем
      if (width <= maxWidthPx) {
        return srcCanvas.toDataURL("image/jpeg", quality);
      }
      const scale = maxWidthPx / width;
      const dst = document.createElement("canvas");
      dst.width = Math.round(width * scale);
      dst.height = Math.round(height * scale);
      const ctx = dst.getContext("2d");
      // чуть лучше ресемплинг
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(srcCanvas, 0, 0, dst.width, dst.height);
      return dst.toDataURL("image/jpeg", quality);
    };

    const hidenPdf = new jsPDF("landscape", "mm", "a4");
    const lists = document.querySelectorAll(".hiden-list");

    for (const [index, list] of lists.entries()) {
      // scale=2 оставляем для чёткости рендеринга шрифтов и линий
      const canvas = await html2canvas(list, {
        scale: 2,
        useCORS: true,
        onclone: (clonedDoc) => {
          const clonedList = clonedDoc.querySelectorAll(".hiden-list")[index];
          if (clonedList) {
            clonedList.style.visibility = "visible";
            clonedList.style.position = "static";
            clonedList.style.zIndex = "auto";
          }
        }
      });

      // Конвертация и сжатие: PNG -> JPEG + кап по пиксельной ширине
      const imgData = canvasToJPEG(canvas, targetPxWidth, 0.85);

      // Поддерживаем пропорции: ширина по всей странице, высота — по аспекту
      const imgWidthMm = A4_WIDTH_MM;
      const imgHeightMm = (canvas.height * imgWidthMm) / canvas.width;

      if (index !== 0) hidenPdf.addPage("a4", "landscape");
      hidenPdf.addImage(imgData, "JPEG", 0, 0, imgWidthMm, Math.min(imgHeightMm, A4_HEIGHT_MM));
    }

    const fileName = `КП № ${formData.kpNumber} от ${formData.kpDate}.pdf`;

    if (await isTMA()) {
      try {
        await MainApi.sendFileToBot(formData.kpNumber, hidenPdf.output('blob'), fileName, buildKpTelegramCaption());
        toast.success('PDF отправлен ботом вам в чат в Telegram');
      } catch (err) {
        console.error('Ошибка при отправке PDF в Telegram:', err);
        toast.error('Не удалось отправить PDF в Telegram');
      }
      return;
    }

    saveAs(hidenPdf.output('blob'), fileName);
  }, [formData, listsKp, buildKpTelegramCaption]);

  const downloadSpec = useCallback(async () => {
    const A4_WIDTH_MM = 297;
    const A4_HEIGHT_MM = 210;
    const TARGET_DPI = 200;
    const MM_PER_INCH = 25.4;
    const targetPxWidth = Math.round((A4_WIDTH_MM / MM_PER_INCH) * TARGET_DPI); // ≈2338px

    const canvasToJPEG = (srcCanvas, maxWidthPx = targetPxWidth, quality = 0.85) => {
      const { width, height } = srcCanvas;
      if (width <= maxWidthPx) {
        return srcCanvas.toDataURL("image/jpeg", quality);
      }
      const scale = maxWidthPx / width;
      const dst = document.createElement("canvas");
      dst.width = Math.round(width * scale);
      dst.height = Math.round(height * scale);
      const ctx = dst.getContext("2d");
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(srcCanvas, 0, 0, dst.width, dst.height);
      return dst.toDataURL("image/jpeg", quality);
    };

    const compactPdf = new jsPDF("landscape", "mm", "a4");
    const listsCompact = document.querySelectorAll(".listCompact");

    for (const [index, list] of listsCompact.entries()) {
      const canvas = await html2canvas(list, {
        scale: 2,
        useCORS: true,
        onclone: (clonedDoc) => {
          const clonedList = clonedDoc.querySelectorAll(".listCompact")[index];
          if (clonedList) {
            clonedList.style.visibility = "visible";
            clonedList.style.position = "static";
            clonedList.style.zIndex = "auto";
          }
        }
      });

      const imgData = canvasToJPEG(canvas, targetPxWidth, 0.85);
      const imgWidthMm = A4_WIDTH_MM;
      const imgHeightMm = (canvas.height * imgWidthMm) / canvas.width;

      if (index !== 0) compactPdf.addPage("a4", "landscape");
      compactPdf.addImage(imgData, "JPEG", 0, 0, imgWidthMm, Math.min(imgHeightMm, A4_HEIGHT_MM));
    }

    const specFileName = `Спецификация к КП № ${formData.kpNumber} от ${formData.kpDate}.pdf`;

    if (await isTMA()) {
      try {
        await MainApi.sendFileToBot(formData.kpNumber, compactPdf.output('blob'), specFileName, buildKpTelegramCaption());
        toast.success('Спецификация отправлена ботом вам в чат в Telegram');
      } catch (err) {
        console.error('Ошибка при отправке спецификации в Telegram:', err);
        toast.error('Не удалось отправить спецификацию в Telegram');
      }
      return;
    }

    saveAs(compactPdf.output('blob'), specFileName);
  }, [formData, listsKp, buildKpTelegramCaption]);

  const downloadKpXlsx = useCallback(async () => {
    try {
      const { blob, fileName } = await MainApi.downloadKpXlsx(formData.kpNumber);

      if (await isTMA()) {
        try {
          await MainApi.sendFileToBot(formData.kpNumber, blob, fileName, buildKpTelegramCaption());
          toast.success('Смета отправлена ботом вам в чат в Telegram');
        } catch (err) {
          console.error('Ошибка при отправке XLSX в Telegram:', err);
          toast.error('Не удалось отправить смету в Telegram');
        }
        return;
      }

      downloadFile(blob, fileName);
    } catch (err) {
      console.error('Ошибка при скачивании XLSX:', err);
      toast.error(`Ошибка при скачивании XLSX: ${err}`);
    }
  }, [formData.kpNumber, buildKpTelegramCaption]);



  const deleteRow = useCallback((listId, rowIndex) => {
    // dispatch({ type: 'DELETE_ROW', payload: { listId, rowIndex } });
    useKpStore.getState().deleteRowFromList(listId, rowIndex);
  }, []);

  const deleteList = useCallback((id) => {
    // dispatch({ type: 'DELETE_LIST', payload: { id } });
    useKpStore.getState().deleteList(id);
    if (!isNewKp) deleteListFromDb(id);
  }, [isNewKp]);

  const addRowOnList = async (row, listId) => {
    // найдём список, чтобы понять текущую длину
    const list = listsKp.find((l) => l.id === listId);
    const nextOrder = (list?.rows?.length ?? 0);
    const rowWithListIdAndOrder = {
      ...row,
      listId,
      order: Number.isInteger(row.order) ? row.order : nextOrder,
    };

    if (!isNewKp) {
      try {
        const savedRow = await MainApi.addRow(rowWithListIdAndOrder);
        // dispatch({
        //   type: 'ADD_ROW_ON_LIST',
        //   payload: { row: savedRow, listId },
        // });
        useKpStore.getState().addRowToList(listId, savedRow);
      } catch (error) {
        console.error('Ошибка при добавлении строки в БД:', error);
      }
    } else {
      // Черновик: пока нет id из БД — сгенерируем временный
      const tempRow = { ...rowWithListIdAndOrder, id: Date.now() };
      // dispatch({
      //   type: 'ADD_ROW_ON_LIST',
      //   payload: { row: tempRow, listId },
      // });
      useKpStore.getState().addRowToList(listId, tempRow);
    }
  };

  const onDeleteRow = useCallback(async (listId, rowIndex) => {
    // локально
    // dispatch({ type: 'DELETE_ROW', payload: { listId, rowIndex } });
    useKpStore.getState().deleteRowFromList(listId, rowIndex);
    // в БД (если КП уже существует)
    if (!isNewKp) {
      const list = listsKp.find(l => l.id === listId);
      const row = list?.rows?.[rowIndex];
      if (row?.id) await deleteRowFromDb(row.id);
    }
  }, [isNewKp, listsKp]);

  const onUpdateRow = useCallback(async (listId, rowIndex, updatedRow) => {
    // локально
    // dispatch({ type: 'UPDATE_ROW', payload: { listId, rowIndex, updatedRow } });
    useKpStore.getState().updateRowInList(listId, rowIndex, updatedRow);
    // в БД (если КП уже существует)
    if (!isNewKp) {
      await updateRowInDb(updatedRow);
    }
  }, [isNewKp]);

  if (!authReady) return null;

  return (
    <TelegramAuthProvider>
      {!isAuth ? (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      ) : (
        <AppLayout>
          <Routes>
            {/* Главная страница */}
            <Route
              path="/"
              element={
                <Home
                  // searchKp={searchKp}
                  // dispatch={dispatch}
                  setIsNewKp={setIsNewKp}
                // getEmptyFormData={getEmptyFormData}
                />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/contractors" element={<ContractorsList />} />
            <Route path="/contractors/new" element={<ContractorForm />} />
            <Route path="/contractors/:id" element={<ContractorDetails />} />
            <Route path="/contractors/:id/edit" element={<ContractorForm />} />
            <Route path="/events" element={<EventsList />} />
            <Route path="/events/new" element={<EventForm />} />
            <Route path="/events/:id" element={<EventDetails />} />
            <Route path="/events/:id/edit" element={<EventForm />} />
            <Route path="/menu" element={<MenuList />} />
            <Route path="/menu/new" element={<MenuForm />} />
            <Route path="/menu/:id" element={<MenuDetails />} />
            <Route path="/menu/:id/edit" element={<MenuForm />} />
            <Route path="/organisation" element={<OrganisationList />} />
            <Route path="/organisation/new" element={<OrganisationForm />} />
            <Route path="/organisation/:id" element={<OrganisationDetails />} />
            <Route path="/organisation/:id/edit" element={<OrganisationForm />} />

            {/* Страница экспериментального прототипа (теперь основная форма создания) */}
            <Route 
              path="/new" 
              element={
                <PrototypeKp 
                  addToDb={addToDb} 
                  isNewKp={isNewKp} 
                />
              } 
            />

            {/* Старая страница формы нового КП (legacy) */}
            <Route
              path="/new-legacy"
              element={
                <Form
                  dateToISO={toISO}
                  listsSummary={listsKp}
                  onSubmit={(data) => addToDb(data, listsKp)}
                  // addList={(rows) => dispatch({ type: 'ADD_ROW_IN_PDF', payload: rows })}
                  kpNumber={formData.kpNumber}
                  formInfo={formData}
                  getProductWeightWithMeasure={getProductWeightWithMeasure}
                  isNewKp={isNewKp}
                  onDeleteRow={onDeleteRow}
                  onUpdateRow={onUpdateRow}
                  onAddRowOnList={addRowOnList}
                  onDeleteList={deleteList}
                />
              }
            />

            <Route
              path="/kp/:kpNumber"
              element={
                <KpLoader
                  // dispatch={dispatch}
                  setIsNewKp={setIsNewKp}
                />
              }
            />

            {/* Страница превью КП */}
            <Route
              path="/preview/:kpNumber"
              element={
                <Preview
                  formData={formData}
                  listsKp={listsKp}
                  isNewKp={isNewKp}
                  // dispatch={dispatch}
                  deleteRow={deleteRow}
                  deleteList={deleteList}
                  deleteRowFromDb={deleteRowFromDb}
                  updateRowInDb={updateRowInDb}
                  addRowOnList={addRowOnList}
                  GetPrice={GetPrice}
                  // downloadPDF={exportPDF}
                  downloadSpec={downloadSpec}
                  downloadKpXlsx={downloadKpXlsx}
                  getProductWeightWithMeasure={getProductWeightWithMeasure}
                  getDeclination={getDeclination}
                  exportHiddenPDF={exportHiddenPDF}
                  kpPreviewSelectors={kpPreviewSelectors}
                  kpPrintSelectors={kpPrintSelectors}
                />
              }
            />
          </Routes>
        </AppLayout>
      )}
      <ToastContainer />
    </TelegramAuthProvider>
  );
}

export default React.memo(App);
